module.exports = __webpack_public_path__ + "img/desktop_news_top_img.0554eb5f.jpg";